import { SET, RESET_STATE } from "@/stores/CommumActionTypes";

const mutations = {
	[SET]: (state, windMonitoringElementsTree) =>
	{
		state.windMonitoringElementsTree = windMonitoringElementsTree;
	},
	[RESET_STATE]: (state) =>
	{
		state.windMonitoringElementsTree = [];
	}
};

export default { mutations };